import { Logger } from 'ui-common/src';
import { removeMenuById, removeMenuByIds } from '../utils/removeMenuByID/removeMenuByID';

export const SIDE_MENU_LOADING = 'SIDE_MENU_LOADING';
export const SIDE_MENU_LOADED = 'SIDE_MENU_LOADED';
export const UPDATE_MENU_FILTER = 'UPDATE_MENU_FILTER';

const sideMenuLoading = () => ({ type: SIDE_MENU_LOADING, loading: true });

const InitializeSideMenu = (featureFlags, leftMenuData) => (dispatch, getState) => {
  dispatch(sideMenuLoading());

  const MENU_TO_ALLOW_IF_PAM_ENABLED = ['assets-sessions', 'privileged-service-account-management'];
  const MENU_TO_ALLOW_IF_PAM_DISABLED = [
    'new-privileged-access',
    'privileged-sessions',
    'past-sessions',
  ];
  const PAM_MENUS_TO_DISALLOW_IF_JFA_ENABLED = ['manage-pam'];
  const ALL_MENUS_TO_DISALLOW_IF_JFA_ENABLED = MENU_TO_ALLOW_IF_PAM_ENABLED.concat(
    MENU_TO_ALLOW_IF_PAM_DISABLED
  ).concat(PAM_MENUS_TO_DISALLOW_IF_JFA_ENABLED);

  const { isPamGen2, isJitForApps, isEmergencyRolesUser, isIntegration } = featureFlags;

  Logger.info(leftMenuData);

  if (leftMenuData && leftMenuData.length > 0) {
    let sideMenu = [
      ...leftMenuData.filter((menu) => menu.id !== (isIntegration ? 'design' : 'integrations')),
    ];
    Logger.info(sideMenu);

    if (isJitForApps && isPamGen2) {
      const pamGen2SubMenu = sideMenu
        .filter((menu) => menu.id === 'home')[0]
        .subMenu.find((subMenuItem) => subMenuItem.id === 'privileged-access');

      // TODO: add localization for JITA and remove subMenuItem id overwrite in future
      if (pamGen2SubMenu) {
        pamGen2SubMenu.id = 'jit-access';
        pamGen2SubMenu.link = '/request/privilegedAccess';
      }

      sideMenu = removeMenuByIds(sideMenu, ALL_MENUS_TO_DISALLOW_IF_JFA_ENABLED);
    } else if (isPamGen2) {
      sideMenu = removeMenuByIds(sideMenu, MENU_TO_ALLOW_IF_PAM_DISABLED);
    }
    if (!isEmergencyRolesUser) {
      sideMenu = removeMenuById(sideMenu, 'request-emergency-access-roles');
    }

    Logger.info(sideMenu);

    dispatch({
      type: SIDE_MENU_LOADED,
      data: sideMenu,
    });
  }
};

const updateMenuFilter = (menuId, isEnabled) => (dispatch, getState) => {
  const state = getState();
  const currentFilter = state.app?.menuFilters?.[menuId];
  const rawSideMenu = state.app?.rawSideMenu;
  
  // Only update if conditions are met
  if (rawSideMenu?.length && currentFilter !== isEnabled) {
    dispatch({
      type: UPDATE_MENU_FILTER,
      menuId,
      isEnabled
    });
  }
};

export { InitializeSideMenu, updateMenuFilter };
